import Axios from "axios";
import axios from "axios"
import { BASE_URL, HIEBUS_CONFIG } from "../auth/authConfig";
import {
    sessionUser,
    sessionUsername,
    sessionAccessToken,
    sessionActiveTime,
    sessionRefreshToken,
    sessionIdToken,
    MAX_INACTIVE_TIME, useKeycloak, config, toaster,
} from "../config";
import Keycloak from "keycloak-js";
import {logActivity} from "./utilService";

let refreshingCall;
let isRefreshing = false;

Axios.interceptors.request.use(
    async (configs) => {
        let token = sessionStorage.getItem(sessionAccessToken);
        if(useKeycloak) {
            let keycloak = new Keycloak({
                realm: 'MQuarkV2',
                url: config.identityServerURL,
                clientId: config.client_id
            })
            await keycloak.init({token: sessionStorage.getItem(sessionAccessToken), refreshToken: sessionStorage.getItem(sessionRefreshToken)}).then((init) => {
                keycloak.updateToken(120).then(()=> {
                    token = keycloak.token
                    sessionStorage.setItem(sessionAccessToken, keycloak.token)
                    sessionStorage.setItem(sessionRefreshToken, keycloak.refreshToken)
                    if (token) {
                        configs.headers["Authorization"] = "Bearer " + token;
                    }
                    configs.headers["Access-Control-Allow-Origin"] = "*";
                    return configs;
                }).catch(error=> {
                    logActivity("APIRequest", `Unable to Refresh Token: ${error}`)
                    Promise.reject(`Unable to Refresh Token`);
                });
            });
            if (token) {
                //(process.env.REACT_APP_CLIENT_AUTH === 'level2') && (token=sessionRefreshToken)
                configs.headers["Authorization"] = "Bearer " + token;
            }
            !(process.env.REACT_APP_CLIENT_AUTH === 'level2') && (configs.headers["Access-Control-Allow-Origin"] = "*");
            return configs;
        } else {
            if (token) {
                configs.headers["Authorization"] = "Bearer " + token;
            }
            return configs;
        }
    },
    (error) => {
        logActivity("APIRequest", `Request Error: ${error}`)
        Promise.reject('Request Error');
    }
);

function refreshToken() {
    if (isRefreshing) {
        return refreshingCall;
    }
    isRefreshing = true;
    const params = new URLSearchParams();
    params.append("client_id", HIEBUS_CONFIG.client_id);
    params.append("client_secret", HIEBUS_CONFIG.client_secret);
    params.append("grant_type", "refresh_token");
    params.append("refresh_token", sessionStorage.getItem(sessionRefreshToken));
    refreshingCall = axios
        .post(HIEBUS_CONFIG.token_endpoint, params)
        .then((token_response) => {
            sessionStorage.setItem(
                sessionAccessToken,
                token_response.data.access_token
            );
            sessionStorage.setItem(
                sessionRefreshToken,
                token_response.data.refresh_token
            );
            refreshingCall = undefined;
            isRefreshing = false;
            return Promise.resolve(true);
        })
        .catch((reason) => {
            console.log('Token refresh error: ', reason)
        });
    return refreshingCall;
}

Axios.interceptors.response.use(
    (response) => {
        sessionStorage.setItem(sessionActiveTime, Date.now());
        return response;
    },
    (error) => {
        const expectedError =
            error.response &&
            error.response.status >= 400 &&
            error.response.status < 500;
        if (!expectedError) {
            logActivity("APIRequest", error)
        } else if (error.response.status === 400) {
            if (
                Date.now() <= Number(sessionStorage.getItem(sessionActiveTime)) + MAX_INACTIVE_TIME
            ) {
                return refreshToken().then((_) => {
                    error.config.headers["Authorization"] =
                        "Bearer " + sessionStorage.getItem(sessionAccessToken);
                    error.config.baseURL = undefined;
                    return Axios.request(error.config);
                });
            }
            sessionStorage.removeItem(sessionUser);
            sessionStorage.removeItem(sessionUsername);
            sessionStorage.removeItem(sessionAccessToken);
            window.location = BASE_URL;
        }
        else if (error.response.status === 403) {
            toaster('error', 'Error Accessing the API');
            console.log("No permission to access API: ", error.config.url)
        }

        return Promise.reject(error);
    }
);

//Axios.defaults.headers.common["Authorization"];

export default {
  get: Axios.get,
  post: Axios.post,
};
